import {
  CENT_MOCK_LINE,
  CONVENIENT_MD_TEST_LINE,
  CONVENIENT_MD_TRANSFER_LINE,
  CTNC_EXISTING_PATIENT_LINE,
  CTNC_EXISTING_PATIENT_TRANSFER_LINE,
  CTNC_NEW_PATIENT_LINE,
  CTNC_NEW_PATIENT_TRANSFER_LINE,
  ENTP_LINE,
  ENTP_MOCK_LINE,
  ENTP_SCI_LINE,
  ENTP_SCI_MOCK_LINE,
  ENTP_SCI_TRANSFER_LINE,
  ENTP_TRANSFER_LINE_MEDIUM_PRIORITY,
  GroupIds,
  NIMBUS_MACON_LINE,
  NIMBUS_MACON_MOCK_LINE,
  NIMBUS_ROCK_HILL_LINE,
  NIMBUS_ROCK_HILL_MOCK_LINE,
  NIMBUS_SCW_LINE,
  NIMBUS_SCW_MOCK_LINE,
  SAMPLE_ALLOW_LIST,
  AXIA_DEMO_LINE,
  AXIA_TRANSFER_LINE,
  SPORT_ORTHO_DEMO_LINE,
  SPORT_ORTHO_TRANSFER_LINE,
  TPR_BILTMORE_LEGACY_IVR_LINE,
  TPR_BILTMORE_VOICE_LINE,
  TPR_BILTMORE_VOICE_MOCK_LINE,
  UPPERLINE_GA_LINE,
  UPPERLINE_GA_MOCK_LINE,
  UPPERLINE_GA_TRANSFER_LINE,
  VOICE_STAGING_TWILIO_NUMBER,
} from "@/shared/group-configs/groups";

export type VoiceInboundRoutingConfig = {
  groupId: GroupIds;
  forwardingNumber: string | null;
  forwardingSendDigits?: string;
  voiceAgentSipUri: string;
  voiceAgentSampleRate: number;
  samplingAllowList: readonly string[];
  alertTag: string;
  runEligibilityCheck: boolean;
};

export const voiceInboundRoutingByNumber: Readonly<Record<string, VoiceInboundRoutingConfig>> = {
  [CTNC_NEW_PATIENT_LINE]: {
    groupId: GroupIds.NIRA_LIVE,
    forwardingNumber: CTNC_NEW_PATIENT_TRANSFER_LINE,
    voiceAgentSipUri: `sip:${CTNC_NEW_PATIENT_LINE}@3pgrb3k9tuv.sip.livekit.cloud`,
    voiceAgentSampleRate: 0.0,
    samplingAllowList: SAMPLE_ALLOW_LIST,
    alertTag: "New Patient Line",
    runEligibilityCheck: true,
  },
  [CTNC_EXISTING_PATIENT_LINE]: {
    groupId: GroupIds.NIRA_LIVE,
    forwardingNumber: CTNC_EXISTING_PATIENT_TRANSFER_LINE,
    voiceAgentSipUri: `sip:${CTNC_EXISTING_PATIENT_LINE}@3pgrb3k9tuv.sip.livekit.cloud`,
    voiceAgentSampleRate: 0.0,
    samplingAllowList: SAMPLE_ALLOW_LIST,
    alertTag: "Existing Patient Line",
    runEligibilityCheck: true,
  },
  [UPPERLINE_GA_LINE]: {
    groupId: GroupIds.UPPERLINE_GEORGIA_LIVE,
    forwardingNumber: UPPERLINE_GA_TRANSFER_LINE,
    voiceAgentSipUri: `sip:${UPPERLINE_GA_LINE}@3pgrb3k9tuv.sip.livekit.cloud`,
    voiceAgentSampleRate: 1.0,
    samplingAllowList: SAMPLE_ALLOW_LIST,
    alertTag: "Upperline GA",
    runEligibilityCheck: true,
  },
  [ENTP_LINE]: {
    groupId: GroupIds.ENT_PARTNERS_LIVE,
    forwardingNumber: ENTP_TRANSFER_LINE_MEDIUM_PRIORITY,
    voiceAgentSipUri: `sip:${ENTP_LINE}@3pgrb3k9tuv.sip.livekit.cloud`,
    voiceAgentSampleRate: 1.0,
    samplingAllowList: SAMPLE_ALLOW_LIST,
    alertTag: "ENT Partners",
    runEligibilityCheck: true,
  },
  [ENTP_SCI_LINE]: {
    groupId: GroupIds.ENT_PARTNERS_SCI_LIVE,
    forwardingNumber: ENTP_SCI_TRANSFER_LINE,
    voiceAgentSipUri: `sip:${ENTP_SCI_LINE}@3pgrb3k9tuv.sip.livekit.cloud`,
    voiceAgentSampleRate: 1.0,
    samplingAllowList: SAMPLE_ALLOW_LIST,
    alertTag: "ENT Partners SCI",
    runEligibilityCheck: true,
  },
  [NIMBUS_SCW_LINE]: {
    groupId: GroupIds.NIMBUS_LIVE,
    forwardingNumber: null,
    voiceAgentSipUri: `sip:${NIMBUS_SCW_LINE}@3pgrb3k9tuv.sip.livekit.cloud`,
    voiceAgentSampleRate: 1.0,
    samplingAllowList: SAMPLE_ALLOW_LIST,
    runEligibilityCheck: true,
    alertTag: "Nimbus Sun City West",
  },
  [NIMBUS_ROCK_HILL_LINE]: {
    groupId: GroupIds.NIMBUS_LIVE,
    forwardingNumber: null,
    voiceAgentSipUri: `sip:${NIMBUS_ROCK_HILL_LINE}@3pgrb3k9tuv.sip.livekit.cloud`,
    voiceAgentSampleRate: 1.0,
    samplingAllowList: SAMPLE_ALLOW_LIST,
    runEligibilityCheck: true,
    alertTag: "Nimbus Rock Hill",
  },
  [NIMBUS_MACON_LINE]: {
    groupId: GroupIds.NIMBUS_LIVE,
    forwardingNumber: null,
    voiceAgentSipUri: `sip:${NIMBUS_MACON_LINE}@3pgrb3k9tuv.sip.livekit.cloud`,
    voiceAgentSampleRate: 1.0,
    samplingAllowList: SAMPLE_ALLOW_LIST,
    runEligibilityCheck: true,
    alertTag: "Nimbus Macon",
  },
  [VOICE_STAGING_TWILIO_NUMBER]: {
    groupId: GroupIds.VALERIE_HEALTH_LIVE_SANDBOX,
    forwardingNumber: VOICE_STAGING_TWILIO_NUMBER,
    voiceAgentSipUri: `sip:${VOICE_STAGING_TWILIO_NUMBER}@3pgrb3k9tuv.sip.livekit.cloud`,
    voiceAgentSampleRate: 1.0,
    samplingAllowList: SAMPLE_ALLOW_LIST,
    runEligibilityCheck: false,
    alertTag: "Voice Staging",
  },
  [CONVENIENT_MD_TEST_LINE]: {
    groupId: GroupIds.CONVENIENT_MD_LIVE_SANDBOX,
    forwardingNumber: CONVENIENT_MD_TRANSFER_LINE,
    voiceAgentSipUri: `sip:${CONVENIENT_MD_TEST_LINE}@3pgrb3k9tuv.sip.livekit.cloud`,
    voiceAgentSampleRate: 1.0,
    samplingAllowList: SAMPLE_ALLOW_LIST,
    runEligibilityCheck: false,
    alertTag: "ConvenientMD Test",
  },
  [SPORT_ORTHO_DEMO_LINE]: {
    groupId: GroupIds.SPORTORTHO_LIVE,
    forwardingNumber: SPORT_ORTHO_TRANSFER_LINE,
    voiceAgentSipUri: `sip:${SPORT_ORTHO_DEMO_LINE}@3pgrb3k9tuv.sip.livekit.cloud`,
    voiceAgentSampleRate: 1.0,
    samplingAllowList: SAMPLE_ALLOW_LIST,
    // Left off deliberately: the pre-warm only shaves latency, and Sport Ortho builds its
    // scheduling context in-call after identity, as TPR does.
    runEligibilityCheck: false,
    alertTag: "Sport Ortho",
  },
  [AXIA_DEMO_LINE]: {
    groupId: GroupIds.VALERIE_HEALTH_LIVE_SANDBOX,
    forwardingNumber: AXIA_TRANSFER_LINE,
    voiceAgentSipUri: `sip:${AXIA_DEMO_LINE}@3pgrb3k9tuv.sip.livekit.cloud`,
    voiceAgentSampleRate: 1.0,
    samplingAllowList: SAMPLE_ALLOW_LIST,
    runEligibilityCheck: false,
    alertTag: "Axia Demo",
  },
  [ENTP_SCI_MOCK_LINE]: {
    groupId: GroupIds.ENT_PARTNERS_SCI_LIVE_SANDBOX,
    forwardingNumber: ENTP_SCI_TRANSFER_LINE,
    voiceAgentSipUri: `sip:${ENTP_SCI_MOCK_LINE}@3pgrb3k9tuv.sip.livekit.cloud`,
    voiceAgentSampleRate: 1.0,
    samplingAllowList: SAMPLE_ALLOW_LIST,
    runEligibilityCheck: false,
    alertTag: "SCENT Mock",
  },
  [ENTP_MOCK_LINE]: {
    groupId: GroupIds.ENT_PARTNERS_LIVE_SANDBOX,
    forwardingNumber: ENTP_TRANSFER_LINE_MEDIUM_PRIORITY,
    voiceAgentSipUri: `sip:${ENTP_MOCK_LINE}@3pgrb3k9tuv.sip.livekit.cloud`,
    voiceAgentSampleRate: 1.0,
    samplingAllowList: SAMPLE_ALLOW_LIST,
    runEligibilityCheck: false,
    alertTag: "ENTP Mock",
  },
  [CENT_MOCK_LINE]: {
    groupId: GroupIds.ENT_PARTNERS_LIVE_SANDBOX,
    forwardingNumber: ENTP_TRANSFER_LINE_MEDIUM_PRIORITY,
    voiceAgentSipUri: `sip:${CENT_MOCK_LINE}@3pgrb3k9tuv.sip.livekit.cloud`,
    voiceAgentSampleRate: 1.0,
    samplingAllowList: SAMPLE_ALLOW_LIST,
    runEligibilityCheck: false,
    alertTag: "CENT Mock",
  },
  [UPPERLINE_GA_MOCK_LINE]: {
    groupId: GroupIds.UPPERLINE_GEORGIA_LIVE_SANDBOX,
    forwardingNumber: UPPERLINE_GA_TRANSFER_LINE,
    voiceAgentSipUri: `sip:${UPPERLINE_GA_MOCK_LINE}@3pgrb3k9tuv.sip.livekit.cloud`,
    voiceAgentSampleRate: 1.0,
    samplingAllowList: SAMPLE_ALLOW_LIST,
    runEligibilityCheck: false,
    alertTag: "Upperline GA Mock",
  },
  [NIMBUS_SCW_MOCK_LINE]: {
    groupId: GroupIds.NIMBUS_LIVE_SANDBOX,
    forwardingNumber: null,
    voiceAgentSipUri: `sip:${NIMBUS_SCW_MOCK_LINE}@3pgrb3k9tuv.sip.livekit.cloud`,
    voiceAgentSampleRate: 1.0,
    samplingAllowList: SAMPLE_ALLOW_LIST,
    runEligibilityCheck: false,
    alertTag: "Nimbus Sun City West Mock",
  },
  [NIMBUS_ROCK_HILL_MOCK_LINE]: {
    groupId: GroupIds.NIMBUS_LIVE_SANDBOX,
    forwardingNumber: null,
    voiceAgentSipUri: `sip:${NIMBUS_ROCK_HILL_MOCK_LINE}@3pgrb3k9tuv.sip.livekit.cloud`,
    voiceAgentSampleRate: 1.0,
    samplingAllowList: SAMPLE_ALLOW_LIST,
    runEligibilityCheck: false,
    alertTag: "Nimbus Rock Hill Mock",
  },
  [NIMBUS_MACON_MOCK_LINE]: {
    groupId: GroupIds.NIMBUS_LIVE_SANDBOX,
    forwardingNumber: null,
    voiceAgentSipUri: `sip:${NIMBUS_MACON_MOCK_LINE}@3pgrb3k9tuv.sip.livekit.cloud`,
    voiceAgentSampleRate: 1.0,
    samplingAllowList: SAMPLE_ALLOW_LIST,
    runEligibilityCheck: false,
    alertTag: "Nimbus Macon Mock",
  },
  [TPR_BILTMORE_VOICE_LINE]: {
    groupId: GroupIds.TPR_BILTMORE_LIVE,
    forwardingNumber: TPR_BILTMORE_LEGACY_IVR_LINE,
    voiceAgentSipUri: `sip:${TPR_BILTMORE_VOICE_LINE}@3pgrb3k9tuv.sip.livekit.cloud`,
    voiceAgentSampleRate: 0.5,
    samplingAllowList: SAMPLE_ALLOW_LIST,
    // TPR resolves eligibility after identity and scheduling context are established in-call.
    runEligibilityCheck: false,
    alertTag: "TPR Biltmore",
  },
  [TPR_BILTMORE_VOICE_MOCK_LINE]: {
    groupId: GroupIds.TPR_BILTMORE_LIVE_SANDBOX,
    forwardingNumber: null,
    voiceAgentSipUri: `sip:${TPR_BILTMORE_VOICE_MOCK_LINE}@3pgrb3k9tuv.sip.livekit.cloud`,
    voiceAgentSampleRate: 1.0,
    samplingAllowList: SAMPLE_ALLOW_LIST,
    runEligibilityCheck: false,
    alertTag: "TPR Biltmore Mock",
  },
};

export function getVoiceInboundRoutingConfig(calledNumber: string): VoiceInboundRoutingConfig | null {
  return voiceInboundRoutingByNumber[calledNumber] ?? null;
}

export function shouldRouteCallToVoiceAgent(
  config: VoiceInboundRoutingConfig,
  fromNumber: string,
  randomValue: number = Math.random()
): boolean {
  return config.samplingAllowList.includes(fromNumber) || randomValue < config.voiceAgentSampleRate;
}
